// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Happy = function Happy(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8 12.643a4.638 4.638 0 004.167-2.606l-.943-.461a3.587 3.587 0 01-6.449 0l-.943.461A4.638 4.638 0 008 12.643zM5.4 5.721a.949.949 0 00-.948.948.948.948 0 10.948-.948zM10.794 5.744a.946.946 0 10.745.925.946.946 0 00-.745-.925z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.756 5.691A7.135 7.135 0 1015.14 8a7.141 7.141 0 00-.384-2.309zM13.725 10.8a6.374 6.374 0 11.647-2.8 6.395 6.395 0 01-.647 2.8z"
    }))
  );
};

export default Happy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Happy.js
// module id = 1020
// module chunks = 0